import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { graphql, gql, compose } from 'react-apollo';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import { Tabs, Tab } from 'material-ui/Tabs';

import Loader from '../../UI/Loader';

import styles from './BatchesList.css';
import Snackbar from 'material-ui/Snackbar';

const townsBatchesQuery = gql`
    query TownsBatchesQuery($tournamentId: ID!) {
        tournament(_id: $tournamentId) {
            p {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
            m {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
            t {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
            v {
                junior {
                    name
                    itemOf
                }
                senior {
                    name
                    itemOf
                }
            }
        }
        towns(tournamentId: $tournamentId) {
            _id
            name {
                ru
                local
            }
            participantsCount
            participantsCountFall
            participantsCountSpring
            batches {
                jury {
                    _id
                    name
                }
                round
                level
                stage
                start
                end
            }
            stats {
                p {
                    junior {
                        registered
                        first
                        second
                        finished
                    }
                    senior {
                        registered
                        first
                        second
                        finished
                    }
                }
                m {
                    junior {
                        registered
                        first
                        second
                        finished
                    }
                    senior {
                        registered
                        first
                        second
                        finished
                    }
                }
                t {
                    junior {
                        registered
                        first
                        second
                        finished
                    }
                    senior {
                        registered
                        first
                        second
                        finished
                    }
                }
                v {
                    junior {
                        registered
                        first
                        second
                        finished
                    }
                    senior {
                        registered
                        first
                        second
                        finished
                    }
                }
            }
            batchesStats {
                p {
                    junior {
                        registered
                        first
                        second
                        finished
                        problemName
                    }
                    senior {
                        registered
                        first
                        second
                        finished
                        problemName
                    }
                }
                m {
                    junior {
                        registered
                        first
                        second
                        finished
                        problemName
                    }
                    senior {
                        registered
                        first
                        second
                        finished
                        problemName
                    }
                }
                t {
                    junior {
                        registered
                        first
                        second
                        finished
                        problemName
                    }
                    senior {
                        registered
                        first
                        second
                        finished
                        problemName
                    }
                }
                v {
                    junior {
                        registered
                        first
                        second
                        finished
                        problemName
                    }
                    senior {
                        registered
                        first
                        second
                        finished
                        problemName
                    }
                }
            }
        }
    }
`;

const startBatchMarkingMutation = gql`
    mutation StartBatchMarkingMutation($townId: ID!, $round: String, $level: String, $stage: String) {
        startBatchMarking(townId: $townId, round: $round, level: $level, stage: $stage) {
            jury {
                name
            }
        }
    }
`;

function getFilter(season) {
    return function(town) {
        return (
            town.stats[season === 'spring' ? 't' : 'p'].junior.registered ||
            town.stats[season === 'spring' ? 't' : 'p'].senior.registered ||
            town.stats[season === 'spring' ? 'v' : 'm'].junior.registered ||
            town.stats[season === 'spring' ? 'v' : 'm'].senior.registered
        );
    };
}

function findActiveBatch(batches, round, level, stage) {
    return (batches || []).find(
        batch => batch.round === round && batch.level === level && batch.stage === stage && !batch.end
    );
}

function getStatus(stage, total, stats, problems) {
    const step = 100 / problems.length;
    let completed = true;

    const background = `linear-gradient(90deg, ${problems
        .map(
            ({ name: problemName }) =>
                stats.find(stat => stat.problemName === problemName) || {
                    registered: total,
                    first: 0,
                    second: 0,
                    finished: 0,
                }
        )
        .map((stat, i) => {
            let color = 'transparent';
            const done = stat[stage === 'final' ? 'finished' : stage];

            if (done) {
                if (done === total) {
                    color = '#b8e6b8';
                } else {
                    color = '#f2ef78';
                    completed = false;
                }
            } else {
                completed = false;
            }

            return `${color} ${step * i}%, ${color} ${step * (i + 1)}%`;
        })
        .join(',')})`;

    return { completed, background };
}

class BatchesList extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
            towns: PropTypes.array,
        }).isRequired,
        history: PropTypes.object.isRequired,
    };

    state = {
        season: 'fall',
        error: '',
    };

    openBatch = event => {
        const { id, round, level } = event.currentTarget.dataset;
        const { match, history } = this.props;

        history.push(`/tournaments/${match.params.number}/towns/${id}/${this.state.season}/${round}/${level}`);
    };

    handleBatchMarkingClick = async (event, townId, round, level, stage) => {
        const { match, history, data, startBatchMarking } = this.props;

        event.stopPropagation();

        try {
            await startBatchMarking({
                variables: {
                    townId,
                    round,
                    level,
                    stage,
                },
            });

            history.push(`/tournaments/${match.params.number}/towns/${townId}/${this.state.season}/${round}/${level}`);
        } catch (e) {
            this.setState({ error: 'Ошибка, эта пачка уже проверяется.' });
            data.refetch();
        }
    };

    renderStageCell = (townId, stats, batchesStats, tournament, batches, round, level, stage) => {
        const registered = stats[round][level].registered;
        const batch = findActiveBatch(batches, round, level, stage);
        const { completed, background } = getStatus(
            stage,
            registered,
            batchesStats[round][level],
            tournament[round][level]
        );

        if (
            (stage === 'second' && stats[round][level].first !== registered) ||
            (stage === 'final' && stats[round][level].second !== registered)
        ) {
            return <TableRowColumn className={styles.stage} />;
        }

        return (
            <TableRowColumn
                className={styles.stage}
                style={{
                    background,
                }}
            >
                {!completed &&
                    (batch ? (
                        batch.jury.name
                    ) : (
                        <span
                            className={styles.startMarking}
                            onClick={e => this.handleBatchMarkingClick(e, townId, round, level, stage)}
                        >
                            Взять на проверку
                        </span>
                    ))}
            </TableRowColumn>
        );
    };

    render() {
        const {
            data: { tournament, towns, loading },
            intl: { formatMessage },
        } = this.props;
        const { season } = this.state;

        const oLevelRound = season === 'spring' ? 't' : 'p';
        const aLevelRound = season === 'spring' ? 'v' : 'm';

        if (loading) {
            return <Loader centerX />;
        }

        if (!towns || !towns.length) {
            return (
                <h2>
                    <FormattedMessage id="TownsList.No towns" />
                </h2>
            );
        }

        let packs = {
            [oLevelRound]: {
                junior: [],
                senior: [],
            },
            [aLevelRound]: {
                junior: [],
                senior: [],
            },
        };

        towns.filter(getFilter(this.state.season)).forEach(town => {
            if (town.stats[oLevelRound].junior.registered) {
                packs[oLevelRound].junior.push(town);
            }

            if (town.stats[oLevelRound].senior.registered) {
                packs[oLevelRound].senior.push(town);
            }

            if (town.stats[aLevelRound].junior.registered) {
                packs[aLevelRound].junior.push(town);
            }

            if (town.stats[aLevelRound].senior.registered) {
                packs[aLevelRound].senior.push(town);
            }
        });

        return (
            <Fragment>
                <Tabs
                    value={season}
                    onChange={season => this.setState({ season })}
                    tabItemContainerStyle={{ background: 'transparent' }}
                >
                    <Tab
                        label={formatMessage({ id: 'OrgHomePage.fall' })}
                        style={{ color: 'rbga(0, 0, 0, 0.87)' }}
                        value="fall"
                    />
                    {Boolean(tournament.t && tournament.v) && (
                        <Tab
                            label={formatMessage({ id: 'OrgHomePage.spring' })}
                            style={{ color: 'rbga(0, 0, 0, 0.87)' }}
                            value="spring"
                        />
                    )}
                </Tabs>

                {!!packs[oLevelRound].junior.length && (
                    <Fragment>
                        <h2>Младший базовый</h2>
                        <Table>
                            <TableHeader
                                displaySelectAll={false}
                                adjustForCheckbox={false}
                                enableSelectAll={false}
                                selectable={false}
                            >
                                <TableRow>
                                    <TableHeaderColumn className={styles.townName}>
                                        <FormattedMessage id="RegListsList.townName" />
                                    </TableHeaderColumn>
                                    <TableHeaderColumn className={styles.papers}>Работ</TableHeaderColumn>
                                    <TableHeaderColumn className={styles.stage}>Первая проверка</TableHeaderColumn>
                                    <TableHeaderColumn className={styles.stage}>Вторая проверка</TableHeaderColumn>
                                    <TableHeaderColumn className={styles.stage}>Финиш</TableHeaderColumn>
                                </TableRow>
                            </TableHeader>
                            <TableBody displayRowCheckbox={false} showRowHover>
                                {packs[oLevelRound].junior.map(
                                    ({
                                        name,
                                        _id,
                                        participantsCountFall,
                                        participantsCountSpring,
                                        stats,
                                        batches,
                                        batchesStats,
                                    }) => (
                                        <TableRow
                                            selectable={false}
                                            onClick={this.openBatch}
                                            data-id={_id}
                                            data-round={oLevelRound}
                                            data-level="junior"
                                            className={styles.row}
                                            key={_id}
                                        >
                                            <TableRowColumn className={styles.townName}>
                                                {name.ru || name.local}
                                            </TableRowColumn>
                                            <TableRowColumn className={styles.papers}>
                                                {stats[oLevelRound].junior.registered}
                                            </TableRowColumn>
                                            {this.renderStageCell(
                                                _id,
                                                stats,
                                                batchesStats,
                                                tournament,
                                                batches,
                                                oLevelRound,
                                                'junior',
                                                'first'
                                            )}
                                            {this.renderStageCell(
                                                _id,
                                                stats,
                                                batchesStats,
                                                tournament,
                                                batches,
                                                oLevelRound,
                                                'junior',
                                                'second'
                                            )}
                                            {this.renderStageCell(
                                                _id,
                                                stats,
                                                batchesStats,
                                                tournament,
                                                batches,
                                                oLevelRound,
                                                'junior',
                                                'final'
                                            )}
                                        </TableRow>
                                    )
                                )}
                            </TableBody>
                        </Table>
                    </Fragment>
                )}

                {!!packs[oLevelRound].senior.length && (
                    <Fragment>
                        <h2>Старший базовый</h2>
                        <Table>
                            <TableHeader
                                displaySelectAll={false}
                                adjustForCheckbox={false}
                                enableSelectAll={false}
                                selectable={false}
                            >
                                <TableRow>
                                    <TableHeaderColumn className={styles.townName}>
                                        <FormattedMessage id="RegListsList.townName" />
                                    </TableHeaderColumn>
                                    <TableHeaderColumn className={styles.papers}>Работ</TableHeaderColumn>
                                    <TableHeaderColumn className={styles.stage}>Первая проверка</TableHeaderColumn>
                                    <TableHeaderColumn className={styles.stage}>Вторая проверка</TableHeaderColumn>
                                    <TableHeaderColumn className={styles.stage}>Финиш</TableHeaderColumn>
                                </TableRow>
                            </TableHeader>
                            <TableBody displayRowCheckbox={false} showRowHover>
                                {packs[oLevelRound].senior.map(
                                    ({
                                        name,
                                        _id,
                                        participantsCountFall,
                                        participantsCountSpring,
                                        stats,
                                        batches,
                                        batchesStats,
                                    }) => (
                                        <TableRow
                                            selectable={false}
                                            onClick={this.openBatch}
                                            data-id={_id}
                                            data-round={oLevelRound}
                                            data-level="senior"
                                            className={styles.row}
                                            key={_id}
                                        >
                                            <TableRowColumn className={styles.townName}>
                                                {name.ru || name.local}
                                            </TableRowColumn>
                                            <TableRowColumn className={styles.papers}>
                                                {stats[oLevelRound].senior.registered}
                                            </TableRowColumn>
                                            {this.renderStageCell(
                                                _id,
                                                stats,
                                                batchesStats,
                                                tournament,
                                                batches,
                                                oLevelRound,
                                                'senior',
                                                'first'
                                            )}
                                            {this.renderStageCell(
                                                _id,
                                                stats,
                                                batchesStats,
                                                tournament,
                                                batches,
                                                oLevelRound,
                                                'senior',
                                                'second'
                                            )}
                                            {this.renderStageCell(
                                                _id,
                                                stats,
                                                batchesStats,
                                                tournament,
                                                batches,
                                                oLevelRound,
                                                'senior',
                                                'final'
                                            )}
                                        </TableRow>
                                    )
                                )}
                            </TableBody>
                        </Table>
                    </Fragment>
                )}

                {!!packs[aLevelRound].junior.length && (
                    <Fragment>
                        <h2>Младший сложный</h2>
                        <Table>
                            <TableHeader
                                displaySelectAll={false}
                                adjustForCheckbox={false}
                                enableSelectAll={false}
                                selectable={false}
                            >
                                <TableRow>
                                    <TableHeaderColumn className={styles.townName}>
                                        <FormattedMessage id="RegListsList.townName" />
                                    </TableHeaderColumn>
                                    <TableHeaderColumn className={styles.papers}>Работ</TableHeaderColumn>
                                    <TableHeaderColumn className={styles.stage}>Первая проверка</TableHeaderColumn>
                                    <TableHeaderColumn className={styles.stage}>Вторая проверка</TableHeaderColumn>
                                    <TableHeaderColumn className={styles.stage}>Финиш</TableHeaderColumn>
                                </TableRow>
                            </TableHeader>
                            <TableBody displayRowCheckbox={false} showRowHover>
                                {packs[aLevelRound].junior.map(
                                    ({
                                        name,
                                        _id,
                                        participantsCountFall,
                                        participantsCountSpring,
                                        stats,
                                        batches,
                                        batchesStats,
                                    }) => (
                                        <TableRow
                                            selectable={false}
                                            onClick={this.openBatch}
                                            data-id={_id}
                                            data-round={aLevelRound}
                                            data-level="junior"
                                            className={styles.row}
                                            key={_id}
                                        >
                                            <TableRowColumn className={styles.townName}>
                                                {name.ru || name.local}
                                            </TableRowColumn>
                                            <TableRowColumn className={styles.papers}>
                                                {stats[aLevelRound].junior.registered}
                                            </TableRowColumn>
                                            {this.renderStageCell(
                                                _id,
                                                stats,
                                                batchesStats,
                                                tournament,
                                                batches,
                                                aLevelRound,
                                                'junior',
                                                'first'
                                            )}
                                            {this.renderStageCell(
                                                _id,
                                                stats,
                                                batchesStats,
                                                tournament,
                                                batches,
                                                aLevelRound,
                                                'junior',
                                                'second'
                                            )}
                                            {this.renderStageCell(
                                                _id,
                                                stats,
                                                batchesStats,
                                                tournament,
                                                batches,
                                                aLevelRound,
                                                'junior',
                                                'final'
                                            )}
                                        </TableRow>
                                    )
                                )}
                            </TableBody>
                        </Table>
                    </Fragment>
                )}

                {!!packs[aLevelRound].senior.length && (
                    <Fragment>
                        <h2>Старший сложный</h2>
                        <Table>
                            <TableHeader
                                displaySelectAll={false}
                                adjustForCheckbox={false}
                                enableSelectAll={false}
                                selectable={false}
                            >
                                <TableRow>
                                    <TableHeaderColumn className={styles.townName}>
                                        <FormattedMessage id="RegListsList.townName" />
                                    </TableHeaderColumn>
                                    <TableHeaderColumn className={styles.papers}>Работ</TableHeaderColumn>
                                    <TableHeaderColumn className={styles.stage}>Первая проверка</TableHeaderColumn>
                                    <TableHeaderColumn className={styles.stage}>Вторая проверка</TableHeaderColumn>
                                    <TableHeaderColumn className={styles.stage}>Финиш</TableHeaderColumn>
                                </TableRow>
                            </TableHeader>
                            <TableBody displayRowCheckbox={false} showRowHover>
                                {packs[aLevelRound].senior.map(
                                    ({
                                        name,
                                        _id,
                                        participantsCountFall,
                                        participantsCountSpring,
                                        stats,
                                        batches,
                                        batchesStats,
                                    }) => (
                                        <TableRow
                                            selectable={false}
                                            onClick={this.openBatch}
                                            data-id={_id}
                                            data-round={aLevelRound}
                                            data-level="senior"
                                            className={styles.row}
                                            key={_id}
                                        >
                                            <TableRowColumn className={styles.townName}>
                                                {name.ru || name.local}
                                            </TableRowColumn>
                                            <TableRowColumn className={styles.papers}>
                                                {stats[aLevelRound].senior.registered}
                                            </TableRowColumn>
                                            {this.renderStageCell(
                                                _id,
                                                stats,
                                                batchesStats,
                                                tournament,
                                                batches,
                                                aLevelRound,
                                                'senior',
                                                'first'
                                            )}
                                            {this.renderStageCell(
                                                _id,
                                                stats,
                                                batchesStats,
                                                tournament,
                                                batches,
                                                aLevelRound,
                                                'senior',
                                                'second'
                                            )}
                                            {this.renderStageCell(
                                                _id,
                                                stats,
                                                batchesStats,
                                                tournament,
                                                batches,
                                                aLevelRound,
                                                'senior',
                                                'final'
                                            )}
                                        </TableRow>
                                    )
                                )}
                            </TableBody>
                        </Table>
                    </Fragment>
                )}
                <Snackbar
                    open={!!this.state.error}
                    message={this.state.error}
                    autoHideDuration={10000}
                    onRequestClose={() => this.setState({ error: '' })}
                />
            </Fragment>
        );
    }
}

export default compose(
    graphql(townsBatchesQuery, {
        options: ({ tournament }) => ({
            variables: {
                tournamentId: tournament._id,
            },
            fetchPolicy: 'no-cache',
        }),
    }),
    graphql(startBatchMarkingMutation, { name: 'startBatchMarking' }),
    injectIntl
)(BatchesList);



// WEBPACK FOOTER //
// ./src/Components/BatchList/BatchesList.js